<template>
  <div class="user_line" v-if="info.user_name">
    <img :src="info.user_avatar" width="128px" height="128px"/>
    <div class="content">
      <div class="top_line">
        <div class="left">
          <div class="SourceHanSansCN">{{ info.user_name }}</div>
          <div>{{ info.identity_type_name }}</div>
        </div>
        <div class="right">
          <div v-if="isSelf">
            <span class="blue_own_button" @click="$router.push('/PersonalCenter')">编辑资料</span>
            <el-popover placement="bottom" width="128" v-if="!info.is_authentication" trigger="click">
              <img src="@/assets/img/home/weixin.png" alt="微信二维码" width="150px" height="128px"/>
              <div style="text-align: center; margin-top: 10px">手机扫码,下载app</div>
              <span class="red_own_button" slot="reference">申请认证</span>
            </el-popover>
            <span class="red_own_button" v-else>已认证</span>
          </div>
          <div v-else>
            <span class="red_own_button" v-if="!info.is_follow" @click="editFollowMethod">关注</span>
            <span class="red_plain_button" v-else @click="editFollowMethod">取消关注</span>
          </div>
        </div>
      </div>
      <div class="bottom_line">
        <div class="item">
          <div class="SourceHanSansCN">{{ info.article_count | filter1 }}</div>
          <div>内容</div>
        </div>
        <div class="item">
          <div class="SourceHanSansCN">{{ info.fabulous_count | filter1 }}</div>
          <div>获赞</div>
        </div>
        <div class="item">
          <div class="SourceHanSansCN">{{ info.follow_count | filter1 }}</div>
          <div>关注</div>
        </div>
        <div class="item">
          <div class="SourceHanSansCN">{{ info.fens_count | filter1 }}</div>
          <div>粉丝</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {editFollow} from '@/api/interfaceApi'
export default {
  name: "UserLine",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgUrl: "https://img2.baidu.com/it/u=3482128345,2137456532&fm=26&fmt=auto&gp=0.jpg",
    };
  },
  methods: {
    // 关注
    editFollowMethod() {
      let cid = JSON.parse(sessionStorage.getItem('loginData')).cid;
      if (cid) {
        let obj = {bid: this.info.id, uid:JSON.parse(sessionStorage.getItem('loginData')).cid};
        editFollow(obj).then((res) => {
          if (res.code == 200) {
            if (this.info.is_follow) {
              this.$message.success(res.msg);
            } else {
              this.$message.success(res.msg);
            }
            this.$emit("attentSuccess");
          }
        });
      } else {
        this.$message.error("请登录后操作");
      }
    }
  },
  computed: {
    //判断是否是自己账号的页面
    isSelf() {
      let cid = sessionStorage.getItem("cid") ? JSON.parse(sessionStorage.getItem("cid")).cid : 0;
      if (cid == this.info.id) return true;
      else return false;
    }
  },
  filters: {
    // 过万后转化
    filter1(val) {
      if (val < 10000)return val;
      else return Math.floor(val / 10000) + "万";
    }
  }
}
</script>

<style lang="scss" scoped>
.user_line {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  > img {
    flex-basis: 128px;
    margin-right: 20px;
    border-radius: 50%;
  }
  > div:nth-child(2) {
    flex: 1;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top_line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        > div:nth-child(1) {
          font-size: 32px;
          color: #333333;
        }
        > div:nth-child(2) {
          font-size: 18px;
          font-weight: 500;
          color: #666666;
          margin: 10px 0px;
          max-width: 600px;
        }
      }
      .right {
        font-size: 18px;
        font-weight: 500;
        .blue_own_button {
          display: inline-block;
          width: 117px;
          height: 48px;
          border-radius: 24px;
          line-height: 48px;
          text-align: center;
          background-color: #1637ff;
          color: #fff;
          cursor: pointer;
        }
        .red_own_button {
          display: inline-block;
          border-radius: 24px;
          width: 228px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          background-color: #fe273b;
          color: #fff;
          margin-left: 40px;
          cursor: pointer;
        }
        .red_plain_button {
          display: inline-block;
          border-radius: 24px;
          width: 228px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border: 1px solid #fe273b;
          box-sizing: border-box;
          color: #fe273b;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .bottom_line {
      width: 420px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item {
        text-align: center;
        > div:nth-child(1) {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        > div:nth-child(2) {
          font-size: 18px;
          font-weight: 500;
          color: #999999;
        }
      }
    }
  }
}
</style>